import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { ModalConfirmation } from '@/lib/v2/organisms';

import { useActionsRecurringMessage } from '@/modules/AutomationModuleNew/hooks/useActionsRecurringMessage';

type DeleteRecurringMessageModalProps = {
  totalRowSelected: number;
  isOpen: boolean;
  onClose: () => void;
  campaignIDs: number[];
  refetchData: () => void;
};

const DeleteRecurringMessageModal = ({
  totalRowSelected,
  isOpen,
  onClose,
  campaignIDs,
  refetchData,
}: DeleteRecurringMessageModalProps) => {
  const { t } = useTranslation();

  const { deleteRecurrent, isLoading } = useActionsRecurringMessage();

  const messagesDeleteRecurrence = useMemo(() => {
    return {
      description:
        totalRowSelected > 1
          ? t('RECURRENT_MESSAGE.DELETE_RECURRENT.MULTIPLE.description')
          : t('RECURRENT_MESSAGE.DELETE_RECURRENT.SINGLE.description'),
      title:
        totalRowSelected > 1
          ? t('RECURRENT_MESSAGE.DELETE_RECURRENT.MULTIPLE.title')
          : t('RECURRENT_MESSAGE.DELETE_RECURRENT.SINGLE.title'),
    };
  }, [totalRowSelected, t]);

  const handleConfirmDeletion = useCallback(async () => {
    await deleteRecurrent(campaignIDs);
    onClose();
    refetchData();
  }, [campaignIDs, deleteRecurrent, onClose, refetchData]);

  return (
    <ModalConfirmation
      description={messagesDeleteRecurrence.description}
      isLoading={isLoading}
      isOpen={isOpen}
      textCancelButton={t('CAMPAIGNS_MAIN.DELETE_CAMPAIGNS.cancelButton')}
      textConfirmButton={t('CAMPAIGNS_MAIN.DELETE_CAMPAIGNS.successButton')}
      title={messagesDeleteRecurrence.title}
      onClose={onClose}
      onConfirmButton={handleConfirmDeletion}
    />
  );
};

export default DeleteRecurringMessageModal;
